import { Icon, Link } from '@acpaas-ui/react-components';
import _ from 'lodash';

const EmailStakeholdersAction = ({ className = '', stakeholders = [] }) => {
  const stakeholdersWithEmail = stakeholders?.filter((st) => !!st.email);
  if (!stakeholdersWithEmail?.length) {
    return null;
  }

  return (
    <Link
      className={`spo-a-email-stakeholders-action a-button-outline a-button--small has-icon ${className}`}
      href={`mailto:${_.uniq(stakeholdersWithEmail?.map((st) => st.email))?.join(', ')}`}
    >
      <Icon className="u-margin-right-xs" name="ai-email-action-unread" />
    </Link>
  );
};

export default EmailStakeholdersAction;
